import angular from 'angular';
import { ArrowBoxComponent } from './arrow-box.component';

export const ArrowBoxModule = angular
  .module('app.components.arrow-box', [])
  .component('updArrowBox', ArrowBoxComponent);
